export default __webpack_public_path__ + "static/media/rightImage.5e74e76d.svg";